import React from 'react';
import ComingSoon from './ComingSoon';
const BlogPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Main Content */}
      <main>
        <ComingSoon />
      </main>
    </div>
  );
};

export default BlogPage;
